/* eslint-disable react/jsx-key */

import { Link } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import React from "react";
// Images
import auraLogo from "assets/images/logos/mainnet/aura/Aura-logo-2.2.svg";
import jackalLogo from "assets/images/logos/mainnet/jackal/jkl.png";
import stargazeLogo from "assets/images/logos/mainnet/stargaze/stars.svg";
import teritoriLogo from "assets/images/logos/mainnet/teritori/chain.svg";
import elysLogo from "assets/images/logos/testnet/elystestnet/elys.png";

const mainnetLogos = {
    aura: auraLogo,
    jackal: jackalLogo,
    stargaze: stargazeLogo,
    teritori: teritoriLogo,
};

const testnetLogos = {
    aura: auraLogo,
    elys: elysLogo,
    jackal: jackalLogo,
};

const blockchains = {
    mainnet: Object.keys(mainnetLogos),
    testnet: Object.keys(testnetLogos),
};

function Blockchains() {
    return (
        <MKBox
            component="section"
            // variant="gradient"
            bgColor="light"
            py={6}
            px={{ xs: 2, lg: 0 }}
            mx={-2}
            container
            item
            borderRadius="md"
            shadow="md"
        >
            <Container>
                <Grid
                    container
                    item
                    justifyContent="center"
                    xs={12}
                    sx={{ mx: "auto", textAlign: "center" }}
                >
                    <MKTypography variant="h1" mb={5}>
                        The Blockchains We Currently Validate on
                    </MKTypography>
                </Grid>
                {Object.entries(blockchains).map(([network, list]) => (
                    <React.Fragment key={network}>
                        <Grid
                            container
                            item
                            justifyContent="center"
                            xs={12}
                            sx={{ mx: "auto", textAlign: "center" }}
                        >
                            <MKTypography variant="body1" fontSize={40} mb={1}>
                                <u>{network.charAt(0).toUpperCase() + network.slice(1)}s</u>
                            </MKTypography>
                        </Grid>
                        <Grid
                            container
                            spacing={3}
                            item
                            justifyContent="center"
                            mt={3}
                            mx={-8}
                            // xs={12}
                            // sx={{ mt: 3, mx: "auto", textAlign: "center" }}
                        >
                            {list.map((name) => (
                                <Grid item xs={3} md={4} lg={2} xl={1} ml={5}>
                                    <Link
                                        to={`/BlockchainDetails/${
                                            network.charAt(0).toUpperCase() + network.slice(1)
                                        }/${name.charAt(0).toUpperCase() + name.slice(1)}`}
                                    >
                                        <MKBox
                                            opacity={1}
                                            width="100px"
                                            textAlign="center"
                                            borderRadius="lg"
                                            shadow="lg"
                                            bgColor="dark"
                                            color="white"
                                            key={name}
                                        >
                                            {name.charAt(0).toUpperCase() + name.slice(1)}
                                            <br></br>
                                            <MKBox
                                                component="img"
                                                src={
                                                    network === "mainnet"
                                                        ? `${mainnetLogos[name]}`
                                                        : `${testnetLogos[name]}`
                                                }
                                                width="100%"
                                                opacity={0.9}
                                                p={1}
                                            />
                                        </MKBox>
                                    </Link>
                                </Grid>
                            ))}
                        </Grid>
                    </React.Fragment>
                ))}
            </Container>
        </MKBox>
    );
}

export default Blockchains;
